<template>
  <rest-list-page-new
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :breadcrumbs="breadcrumbs"
  >
    <template slot="table">
      <rest-list-column
        prop="name"
        :title="$t('Metabase_MetabaseDashboard_Field_Name')"
        :route="rowClickRoute"
        :min-width="300"
      />

      <rest-list-column
        prop="description"
        :title="$t('Metabase_MetabaseDashboard_Field_Description')"
        :min-width="300"
      />
    </template>

    <template slot="actions">
      <el-button
        type="primary"
        plain
        @click="manage"
        icon="el-icon-setting"
        v-if="$hasFeature('hasMetabaseAccess')"
      >
        {{ $t('Metabase_MetabaseDashboard_ManageDashboards') }}
      </el-button>
    </template>
  </rest-list-page-new>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListPageNew from '../../../common/components/rest/RestListPageNew'

export default {
  name: 'MetabaseDashboardList',

  components: {
    RestListPageNew,
    RestListColumn
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `metabase-dashboards`
      })
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('IntelligenceDashboard_Title'),
          route: projectRoute({
            name: 'CustomerIntelligence'
          })
        },
        {
          label: this.$t('Metabase_MetabaseDashboardListPage_Title')
        }
      ]
    },

    canManage() {
      return (
        this.$hasFeature('hasMetabaseAccess') &&
        this.$can('MetabaseProject:FullAccess')
      )
    }
  },

  methods: {
    rowClickRoute(row) {
      return projectRoute({
        name: 'MetabaseDashboard',
        query: {
          id: row.id
        }
      })
    },

    manage() {
      this.$router.push(
        projectRoute({
          name: 'MetabaseProjectApplication',
          query: {
            manage: true
          }
        })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseDashboardList.vue